import { memo } from 'react';
function NextStopCompliancePickupMarker({
  stopSequence,
  textColor,
  color,
  strokeColor,
  size = 25
}) {
  strokeColor = strokeColor || textColor;
  const shiftLeft = stopSequence && stopSequence < 10 ? 0 : -3;
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <rect
        x="1.5"
        y="1"
        width={size - 2}
        height={size - 2}
        rx="1.5"
        fill={color}
        stroke={strokeColor}
        strokeWidth={1}
      />
      <text
        id={8}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={10}
        fontWeight={500}
        fill={textColor}>
        <tspan x={9 + shiftLeft} y={15}>
          {stopSequence}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(NextStopCompliancePickupMarker);
